import { createContext, useContext } from 'react';

export const UnreadMessagesContext = createContext({
  unreadMessagesCount: 0,
  chatUnreadCount: 0,
  emailUnreadCount: 0,
  refreshUnreadMessagesCount: () => {}
});

export const useUnreadMessages = () => useContext(UnreadMessagesContext);
